import {LoadImages} from './LoadImages';
import {prepareManifest} from '../../../helpers/prepareManifest';
// import {Utils} from '../../../../../viscomjs/utils/utils';
import {ResourcesStorage} from '../../../../../viscomjs/load/ResourcesStorage';
import {ImportStoriesToBuild} from '../../../../stories/ImportStoriesToBuild';
import {storeStoriesPack} from '../../../components/storiesDisplay/StoriesFactory';
import {CoreModel} from '../../../core/model/CoreModel';

const LoadStory = (src, doThat, progressUpdate, critical) => {
    //
    const _storage = ResourcesStorage.getIsolatedInstance();

    const _instantiate = pack => {
        return new Promise(resolve => {
            if (!pack) resolve(null);

            resolve(pack.default());
        });
    };

    const _loadImages = pack => {
        return new Promise(resolve => {
            if (!pack) resolve(null);

            LoadImages(prepareManifest(pack.getManifest()), true, progressUpdate, _storage)
                .then(() => {
                    resolve(pack);
                })
                .catch(() => {
                    resolve(pack);
                });
        });
    };

    const _fillPackImages = pack => {
        return new Promise(resolve => {
            if (!pack) resolve(null);

            const src = _storage.getItemsMap();
            const tgt = pack.getImages();
            let name;

            for (name in src) {
                if (!src.hasOwnProperty(name)) continue;
                tgt[name] = src[name] ? src[name].data || src[name].result : null;
            }

            resolve(pack);
        });
    };

    const _initiatePackInstances = pack => {
        return new Promise(resolve => {
            if (!pack) resolve(null);

            pack.initiateInstances();
            resolve(pack);
        });
    };

    return new Promise((resolve, reject) => {
        if (!doThat) {
            reject(`A Story ${src} has not been constructed correctly`);
            return;
        }
        ImportStoriesToBuild(src)
            .then(_instantiate)
            .then(_loadImages)
            .then(_fillPackImages)
            .then(_initiatePackInstances)
            .then(pack => {
                if (pack) {
                    storeStoriesPack(pack, src);
                    CoreModel.instance().setPackIsReady(src);
                    resolve(pack);
                } else if (critical) reject(`A Story ${src} has not been constructed correctly`);
                else resolve(null);
            })
            .catch((/* err */) => {
                // console.log(err);
                if (critical) reject(`A Story ${src} has not been constructed correctly`);
                else resolve(null);
            });
    });
};

const LoadStoryFunction = (src, progressUpdate) => {
    return doThat => {
        return LoadStory(src, doThat, progressUpdate);
    };
};

export {LoadStory, LoadStoryFunction};
export default LoadStory;
